import FirebaseApp from '../FirebaseApp'
import { BuildConfig } from '../config/BuildConfig'

export type EmailMyListPayload = {
  listId: string
  emailAddress: string
  marketingOptIn: boolean
  userType: 'consumer' | 'electrician' | 'wholesaler'
} | {
  listId: string
  emailAddress: string
  marketingOptIn: boolean
  userType: 'consumer' | 'electrician' | 'wholesaler'
  name: string
  message: string
}

export default async function emailMyList(payload: EmailMyListPayload): Promise<string> {
  const { listId, emailAddress, marketingOptIn, userType } = payload

  const data = {
    listId,
    emailAddress,
    marketingOptIn,
    userType,
    brand: BuildConfig.brand.brandName,
  }

  return FirebaseApp.functions()
    .httpsCallable('emailMyList')(data)
    .then(arg => arg.data as string)
}
